import React from "react";
import { Instagram, Twitter, Linkedin, Phone, Mail } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_fintech-flow-18/artifacts/0ej5c54m_digi.png";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 py-14 overflow-hidden">
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[70%] h-[60%] radial-glow-violet blur-3xl opacity-40" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="Digital Onboarding" className="h-10 w-auto object-contain" />
            <span className="font-display font-bold text-lg leading-tight">
              Digital <span className="text-gradient">Onboarding</span>
            </span>
          </div>
          <p className="mt-4 text-sm text-slate-400 max-w-sm leading-relaxed">
            Helping Indian shop owners, CSC centers and service providers bring
            their businesses online and grow faster. A product of{" "}
            <span className="text-white">DigIndia PayTech Pvt. Ltd.</span>
          </p>
          <div className="mt-5 space-y-2 text-sm text-slate-300">
            <p className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-violet-300" />
              <a href="tel:+919141302057" className="hover:text-white">+91 9141302057</a>
            </p>
            <p className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-violet-300" />
              <a href="mailto:care@digitalonbaording.in" className="hover:text-white">care@digitalonbaording.in</a>
            </p>
          </div>
          <div className="mt-6 flex gap-3">
            {[Instagram, Twitter, Linkedin].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="w-9 h-9 rounded-full glass flex items-center justify-center hover:border-violet-500/50 transition-colors"
                data-testid={`footer-social-${i}`}
                aria-label="social"
              >
                <Icon className="w-4 h-4 text-slate-300" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-widest text-slate-500">Explore</p>
          <ul className="mt-4 space-y-2 text-sm text-slate-300">
            <li><a href="#journey" className="hover:text-violet-300">Journey</a></li>
            <li><a href="#services" className="hover:text-violet-300">Services</a></li>
            <li><a href="#why" className="hover:text-violet-300">Why Us</a></li>
            <li><a href="#faq" className="hover:text-violet-300">FAQ</a></li>
            <li><a href="/admin" className="hover:text-violet-300">Admin</a></li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-widest text-slate-500">Company</p>
          <ul className="mt-4 space-y-2 text-sm text-slate-300">
            <li><a href="#" className="hover:text-violet-300">About</a></li>
            <li><a href="#" className="hover:text-violet-300">Careers</a></li>
            <li><a href="#" className="hover:text-violet-300">Privacy</a></li>
            <li><a href="#" className="hover:text-violet-300">Terms</a></li>
          </ul>
        </div>
      </div>
      <div className="relative mt-12 pt-6 border-t border-white/5 max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} DigIndia PayTech Pvt. Ltd. All rights reserved.</p>
        <p className="text-xs text-slate-500">Made in India · For Indian businesses 🇮🇳</p>
      </div>
    </footer>
  );
}
